/* PKGD G4 product page — gallery, zoom lightbox, variant price sync */
(function () {
  document.querySelectorAll('[data-g4-gallery]').forEach(function (gallery) {
    var thumbs = Array.from(gallery.querySelectorAll('[data-g4-thumb]'));
    var slides = Array.from(gallery.querySelectorAll('[data-g4-slide]'));
    var zoom = gallery.querySelector('[data-g4-zoom]');
    var lightbox = gallery.querySelector('[data-g4-lightbox]');
    var lightboxImg = lightbox && lightbox.querySelector('img');

    function pauseMedia(slide) {
      var video = slide.querySelector('video');
      if (video) video.pause();
      var iframe = slide.querySelector('iframe');
      if (iframe) iframe.src = iframe.src;
    }

    function show(index) {
      slides.forEach(function (slide, i) {
        if (i !== index && slide.classList.contains('is-active')) pauseMedia(slide);
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (zoom) zoom.hidden = !slides[index] || !slides[index].hasAttribute('data-zoom-src');
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        show(i);
      });
    });

    if (zoom && lightbox && lightboxImg) {
      zoom.addEventListener('click', function () {
        var active = gallery.querySelector('[data-g4-slide].is-active');
        if (!active || !active.dataset.zoomSrc) return;
        lightboxImg.src = active.dataset.zoomSrc;
        lightboxImg.alt = active.dataset.zoomAlt || '';
        lightbox.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      });
      function close() {
        lightbox.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      lightbox.addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('is-open')) close();
      });
    }

    var start = thumbs.findIndex(function (t) {
      return t.classList.contains('is-active');
    });
    show(start < 0 ? 0 : start);
  });

  document.querySelectorAll('[data-g4-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-g4-variant-select]');
    if (!select) return;
    var scope = form.closest('.g4-info') || document;
    var price = scope.querySelector('[data-g4-price]');
    var compare = scope.querySelector('[data-g4-compare]');
    var button = form.querySelector('[type="submit"]');

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (price) price.textContent = opt.dataset.price;
      if (compare) {
        compare.textContent = opt.dataset.compare || '';
        compare.hidden = !opt.dataset.compare;
      }
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.addText : button.dataset.soldText;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    });
  });
})();
